import React, { Component } from "react";
import { Form, Table, Button, Modal } from "react-bootstrap";
import { Droppable, DragDropContext, Draggable } from "react-beautiful-dnd";
import { DatePicker } from "../../../component/DatePicker";
import { DatePickerStyled } from "../../../component/DatePickerMilestone";
import { get, isEmpty } from "lodash";
import { getLocalstorage } from "../../../helper";
import deleteIcon from "./../../../assets/icon-delete.svg";
import MilestoneInfoIcon from "./../../../assets/info_milestone.png";
import DisableCheckbox from "./../../../assets/DisableCheckbox.svg";
import { OverlayTrigger, Tooltip, Image } from "react-bootstrap";
import { DEPENDENT_TYPE, _showMilestoneAction } from "./milestone.helper";
import { toast } from "react-toastify";
import { successToastStyle, errorToastStyle } from "../../../customToast";
class MilestoneTable extends Component {
  getSavedPhaseTable = (bucketId, tableIndex, bucketMilestoneCOS) => {
    const bucket =
      bucketMilestoneCOS &&
      bucketMilestoneCOS.find(b => b.bucketId === bucketId);
    const tables = (bucket && bucket.milestoneTableDataCOS) || [];
    return tables.find(t => t.tableIndex === tableIndex) || tables[tableIndex];
  };

  mergeCustomMilestones = (
    catalogItems,
    bucketId,
    tableIndex,
    bucketMilestoneCOS
  ) => {
    const table = this.getSavedPhaseTable(
      bucketId,
      tableIndex,
      bucketMilestoneCOS
    );
    const savedMilestones = (table && table.milestoneDataCOS) || [];
    const savedIds = new Set(
      savedMilestones
        .filter(ms => ms && ms.milestone)
        .map(ms => Number(ms.milestone.id))
    );

    // Keep predefined milestones, rows being added right now, and custom
    // milestones that are saved in THIS phase. Drop custom milestones that
    // only belong to other phases.
    const base = (catalogItems || []).filter(
      item =>
        item.predefined !== false ||
        item.id == null ||
        item.newRow ||
        savedIds.has(Number(item.id))
    );

    const existingIds = new Set(base.map(item => Number(item.id)));

    const customItems = savedMilestones
      .filter(
        ms => ms && ms.milestone && !existingIds.has(Number(ms.milestone.id))
      )
      .map(ms => ({
        id: ms.milestone.id,
        name: ms.milestone.name,
        predefined: !!ms.milestone.predefined,
        phaseIndex: tableIndex
      }));

    // return customItems.length ? [...base, ...customItems] : base;
    const merged = customItems.length ? [...base, ...customItems] : base;

    // Keep the order of rows already on screen; new rows go to the end.
    // (this.state is undefined when called from the constructor.)
    const current = (this.state && this.state.tableItems) || [];
    if (!current.length) return merged;

    const orderOf = new Map();
    current.forEach((it, i) => {
      if (it && it.id != null) orderOf.set(Number(it.id), i);
    });

    return merged
      .map((item, i) => ({ item, i }))
      .sort((a, b) => {
        const ai =
          a.item.id != null && orderOf.has(Number(a.item.id))
            ? orderOf.get(Number(a.item.id))
            : Infinity;
        const bi =
          b.item.id != null && orderOf.has(Number(b.item.id))
            ? orderOf.get(Number(b.item.id))
            : Infinity;
        if (ai !== bi) return ai - bi; // known rows keep their position
        return a.i - b.i; // unknown rows keep catalog order, after known ones
      })
      .map(x => x.item);
  };
  // mergeCustomMilestones = (
  //   catalogItems,
  //   bucketId,
  //   tableIndex,
  //   bucketMilestoneCOS
  // ) => {
  //   const base = catalogItems || [];
  //   const bucket =
  //     bucketMilestoneCOS &&
  //     bucketMilestoneCOS.find(b => b.bucketId === bucketId);
  //   const table =
  //     bucket &&
  //     bucket.milestoneTableDataCOS &&
  //     bucket.milestoneTableDataCOS[tableIndex];
  //   const savedMilestones = (table && table.milestoneDataCOS) || [];
  //   const existingIds = new Set(base.map(item => item.id));

  //   const customItems = savedMilestones
  //     .filter(ms => ms.milestone && !existingIds.has(ms.milestone.id))
  //     .map(ms => ({
  //       id: ms.milestone.id,
  //       name: ms.milestone.name,
  //       predefined: !!ms.milestone.predefined,
  //       phaseIndex: tableIndex
  //     }));

  //   return customItems.length ? [...base, ...customItems] : base;
  // };
  constructor(props) {
    super(props);
    const { milestones, bucketId, tableIndex, bucketMilestoneCOS } = props; // add tableIndex, bucketMilestoneCOS
    const bucketIndex = milestones.findIndex(
      mbucket => mbucket.bucket.id == bucketId
    );
    const milestonesData =
      !isEmpty(milestones[bucketIndex]) &&
      !isEmpty(milestones[bucketIndex].newMilestoneData) &&
      !isEmpty(milestones[bucketIndex].newMilestoneData[props.tableIndex]) &&
      milestones[bucketIndex].newMilestoneData[props.tableIndex];
    const initialItems = milestonesData || props.defaultMilestoneData || [];
    this.state = {
      tableItems: this.mergeCustomMilestones(
        initialItems,
        bucketId,
        tableIndex,
        bucketMilestoneCOS
      ),
      milestoneDataForReason: {},
      showPopup: false,
      showInfoPopup: false,
      startDates: []
    };
  }
  componentDidMount() {
    const { bucketMilestoneCOS } = this.props;
    bucketMilestoneCOS.forEach(bucket => {
      if (
        bucket.milestoneTableDataCOS &&
        bucket.milestoneTableDataCOS.length > 0
      ) {
        bucket.milestoneTableDataCOS.forEach(tableData => {
          if (
            tableData.milestoneDataCOS &&
            tableData.milestoneDataCOS.length > 0
          ) {
            tableData.milestoneDataCOS.forEach(milestone => {
              if (milestone.completed === true && milestone.id) {
                this.state.startDates.push(milestone.id);
              }
            });
          }
        });
      }
    });

    //console.log(this.state.startDates)
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      bucketId,
      milestones,
      tableIndex,
      cabinetMilestone,
      defaultMilestoneData,
      cabinetbucketId
    } = this.props;
    if (cabinetMilestone) {
      const { bucketId: prevBucketId } = prevProps;

      const bucketIndex = milestones.findIndex(
        mbucket => mbucket.bucket.id == cabinetbucketId
      );
      // console.log(bucketId, milestones, tableIndex,bucketIndex);
      const currentTableItems =
        bucketIndex > -1 &&
        milestones[bucketIndex] &&
        milestones[bucketIndex].newMilestoneData &&
        milestones[bucketIndex].newMilestoneData[tableIndex]
          ? milestones[bucketIndex].newMilestoneData[tableIndex]
          : [];

      // Bucket changed
      // if (bucketId && prevBucketId !== bucketId) {
      //   this.setState({
      //     tableItems: currentTableItems
      //   });
      //   return;
      // }

      // // Milestones changed
      // if (prevProps.milestones !== milestones) {
      //   if (currentTableItems !== this.state.tableItems) {
      //     this.setState({
      //       tableItems: currentTableItems
      //     });
      //   }
      //   return;
      // }
      if (bucketId && prevBucketId !== bucketId) {
        this.setState({
          tableItems: this.mergeCustomMilestones(
            currentTableItems,
            bucketId,
            tableIndex,
            this.props.bucketMilestoneCOS
          )
        });
        return;
      }

      if (prevProps.milestones !== milestones) {
        if (currentTableItems !== this.state.tableItems) {
          this.setState({
            tableItems: this.mergeCustomMilestones(
              currentTableItems,
              bucketId,
              tableIndex,
              this.props.bucketMilestoneCOS
            )
          });
        }
        return;
      }
      const isActiveBucket =
        bucketIndex > -1 &&
        milestones[bucketIndex] &&
        milestones[bucketIndex].bucket &&
        milestones[bucketIndex].bucket.id;

      // Load default milestone data only once
      if (
        isActiveBucket &&
        isEmpty(this.state.tableItems) &&
        !isEmpty(defaultMilestoneData) &&
        prevState.tableItems !== defaultMilestoneData
      ) {
        // this.setState({
        //   tableItems: defaultMilestoneData
        // });
        this.setState({
          tableItems: this.mergeCustomMilestones(
            defaultMilestoneData,
            bucketId,
            tableIndex,
            this.props.bucketMilestoneCOS
          )
        });
      }
    } else {
      const { bucketId: prevBucketId } = prevProps;
      const bucketIndex = milestones.findIndex(
        mbucket => mbucket.bucket.id == bucketId
      );

      if (!!bucketId && prevBucketId !== bucketId) {
        const currentTableItems =
          !!milestones &&
          !!milestones[bucketIndex] &&
          !!milestones[bucketIndex].newMilestoneData &&
          !!milestones[bucketIndex].newMilestoneData[tableIndex] &&
          milestones[bucketIndex].newMilestoneData[tableIndex];

        this.setState({
          tableItems: this.mergeCustomMilestones(
            currentTableItems || [],
            bucketId,
            tableIndex,
            this.props.bucketMilestoneCOS
          )
        });
      }

      if (prevProps.milestones !== milestones) {
        setTimeout(() => {
          const currentTableItems =
            !!milestones &&
            !!milestones[bucketIndex] &&
            !!milestones[bucketIndex].newMilestoneData &&
            !!milestones[bucketIndex].newMilestoneData[tableIndex] &&
            milestones[bucketIndex].newMilestoneData[tableIndex];

          this.setState({
            tableItems: this.mergeCustomMilestones(
              currentTableItems || [],
              bucketId,
              tableIndex,
              this.props.bucketMilestoneCOS
            )
          });
        }, 0);
      }

      let isActiveBucket =
        !!milestones[bucketIndex] &&
        !!milestones[bucketIndex].bucket &&
        !!milestones[bucketIndex].bucket.id;

      if (
        isEmpty(this.state.tableItems) &&
        !!this.props.defaultMilestoneData &&
        isActiveBucket
      ) {
        this.setState({
          tableItems: this.mergeCustomMilestones(
            this.props.defaultMilestoneData,
            bucketId,
            tableIndex,
            this.props.bucketMilestoneCOS
          )
        });
      }
    }

    // else {
    //   const { bucketId: prevBucketId } = prevProps;
    //   const bucketIndex = milestones.findIndex(
    //     mbucket => mbucket.bucket.id == bucketId
    //   );
    //   // console.log(bucketId, milestones, tableIndex);
    //   if (!!bucketId && prevBucketId !== bucketId) {
    //     this.setState({
    //       tableItems:
    //         !!milestones &&
    //         !!milestones[bucketIndex] &&
    //         !!milestones[bucketIndex].newMilestoneData &&
    //         !!milestones[bucketIndex].newMilestoneData[tableIndex] &&
    //         milestones[bucketIndex].newMilestoneData[tableIndex]
    //     });
    //   }

    //   if (prevProps.milestones !== milestones) {
    //     setTimeout(() => {
    //       this.setState({
    //         tableItems:
    //           !!milestones &&
    //           !!milestones[bucketIndex] &&
    //           !!milestones[bucketIndex].newMilestoneData &&
    //           !!milestones[bucketIndex].newMilestoneData[tableIndex] &&
    //           milestones[bucketIndex].newMilestoneData[tableIndex]
    //       });
    //     }, 0);
    //   }
    //   let isActiveBucket =
    //     !!milestones[bucketIndex] &&
    //     !!milestones[bucketIndex].bucket &&
    //     !!milestones[bucketIndex].bucket.id;

    //   if (
    //     isEmpty(this.state.tableItems) &&
    //     !!this.props.defaultMilestoneData &&
    //     isActiveBucket
    //   ) {
    //     this.setState({
    //       tableItems: this.props.defaultMilestoneData
    //     });
    //   }
    // }
  }
  handleDragStart = results => {
    this.setState({
      selectedTableIndex: this.props.tableIndex
    });
  };

  handleDragEnd = results => {
    const { handleTableOrder } = this.props;
    if (!results.destination) return;
    let tempItems = [...this.state.tableItems];
    let [selectedRow] = tempItems.splice(results.source.index, 1);
    tempItems.splice(results.destination.index, 0, selectedRow);
    this.setState(
      {
        tableItems: tempItems,
        selectedTableMilestoneDataId: selectedRow.mileStoneTableDataId
      },
      () => {
        handleTableOrder(
          tempItems,
          results.source.index,
          results.destination.index,
          this.state.selectedTableIndex
        );
      }
    );
  };

  handleCheckbox(id, checked) {
    this.setState(
      { startDates: this.state.startDates.filter(item => item !== id) },
      () => {
        //console.log(this.state.startDates)
      }
    );
    //console.log(id,checked)
  }

  handleCheckboxChange(revisedScheduledFinshDate, revisedScheduledStartDate) {
    if (revisedScheduledFinshDate != null) {
      const date = new Date(revisedScheduledFinshDate);
      const today = new Date();

      // Set the time of today to midnight to ensure accurate date-only comparison.
      today.setHours(0, 0, 0, 0);

      // Set the time of the timestamp date to midnight for accurate comparison.
      const timestampDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate()
      );
      return timestampDate > today;
    } else {
      const date = new Date(revisedScheduledStartDate);
      const today = new Date();

      // Set the time of today to midnight to ensure accurate date-only comparison.
      today.setHours(0, 0, 0, 0);

      // Set the time of the timestamp date to midnight for accurate comparison.
      const timestampDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate()
      );
      return timestampDate > today;
    }
  }
  onModalChange = async (
    event,
    key,
    bucketID,
    milestoneID,
    milestoneName,
    delayReasonAdded,
    isDisabled,
    _bucketIndex,
    _tableIndex
  ) => {
    const {
      openMilestoneEdit,
      projectId,
      checkIssueBeforeDisable,
      bucketMilestoneCOS
    } = this.props;
    let issueExists = true;
    let _reason = delayReasonAdded || "";
    let _milestoneObj = {
      reason: _reason,
      key,
      bucketID,
      milestoneID,
      milestoneName,
      isDisabled
    };
    if (key === "addReason") {
      event.preventDefault();
      this.setState({
        milestoneDataForReason: _milestoneObj,
        showPopup: true
      });
    }

    if (key === "action") {
      const selectedTableId =
        bucketMilestoneCOS[_bucketIndex].milestoneTableDataCOS[_tableIndex]
          .milestoneTable.id || null;
      if (openMilestoneEdit) {
        const issueExistsForDisablePayload = {
          bucketId: bucketID,
          milestoneId: milestoneID,
          milestoneTableId: selectedTableId,
          projectId
        };
        if (!!selectedTableId) {
          try {
            const response = await checkIssueBeforeDisable(
              undefined,
              issueExistsForDisablePayload
            );
            issueExists = get(response, "data", null);
            if (!issueExists) {
              toast.error(
                <p className="toast-text-alignment">Issue Already Exists</p>,
                errorToastStyle
              );
            }
          } catch (error) {
            console.log(error);
          }
        }
      }
      if (!selectedTableId || (!!selectedTableId && issueExists)) {
        if (isDisabled) {
          this.setState({
            milestoneDataForReason: _milestoneObj,
            showPopup: true
          });
        } else {
          this.props.onChange(
            { reason: "", isDisabled },
            key,
            bucketID,
            milestoneID,
            milestoneName,
            this.props.tableIndex,
            true
          );
        }
      }
    }
  };

  onModalHide = () => {
    this.setState({
      milestoneDataForReason: {},
      showPopup: false
    });
  };

  onReasonHandler = value => {
    const { milestoneDataForReason } = this.state;
    let updatedReason = milestoneDataForReason;
    updatedReason.reason = value.trim() === "" ? "" : value;
    this.setState({
      milestoneDataForReason: updatedReason
    });
  };
  ZIndex = value => {
    this.props.ZIndex(value);
  };
  addReason = () => {
    const { onChange, tableIndex } = this.props;
    const {
      milestoneDataForReason: {
        reason,
        key,
        bucketID,
        milestoneID,
        milestoneName,
        isDisabled
      }
    } = this.state;
    onChange(
      { reason, isDisabled },
      key,
      bucketID,
      milestoneID,
      milestoneName,
      tableIndex,
      true
    );
    this.onModalHide();
  };

  addTableRow = e => {
    e.preventDefault();
    const { tableItems } = this.state;
    let updatedTableItems = [...tableItems];
    let _obj = {
      id: null,
      name: "",
      newRow: true,
      predefined: false
    };
    updatedTableItems = [...updatedTableItems, _obj];
    this.setState({
      tableItems: updatedTableItems
    });
  };

  deleteRow = async (e, id, name, _bucketIndex, _tableIndex) => {
    e.preventDefault();
    const { tableItems } = this.state;
    const { checkIssueBeforeDeletion } = this.props;
    const {
      onChange,
      bucketId,
      tableIndex,
      deleteNewMilestoneAction,
      openMilestoneEdit,
      projectId,
      bucketMilestoneCOS
    } = this.props;
    let updatedTableItems = [...tableItems];
    let issueExists = false;
    if (openMilestoneEdit) {
      const selectedTableId =
        bucketMilestoneCOS[_bucketIndex].milestoneTableDataCOS[_tableIndex]
          .milestoneTable.id || null;
      if (!selectedTableId) {
        // For dynamic phase item which is not available in database
        this.removeNewPhaseItem(id, _bucketIndex);
      } else {
        const issueExistsForDeletePayload = {
          bucketId,
          milestoneId: id,
          milestoneTableId: selectedTableId,
          projectId
        };
        try {
          const response = await checkIssueBeforeDeletion(
            undefined,
            issueExistsForDeletePayload
          );
          issueExists = get(response, "data", null);
          if (issueExists === false) {
            toast.error(
              <p className="toast-text-alignment">Issue Already Exists</p>,
              errorToastStyle
            );
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
    if (issueExists) {
      if (id !== null) {
        // let getRowIndex = updatedTableItems.findIndex(item => item.id === id);
        // updatedTableItems.splice(getRowIndex, 1);
        let getRowIndex = updatedTableItems.findIndex(
          item => Number(item.id) === Number(id)
        );
        if (getRowIndex !== -1) updatedTableItems.splice(getRowIndex, 1);
        this.setState(
          {
            tableItems: updatedTableItems
          },
          () => {
            onChange(null, "deleteRow", bucketId, id, name, tableIndex, true);
          }
        );
        deleteNewMilestoneAction({
          milestoneID: id,
          bucketID: bucketId,
          phaseIndex: tableIndex,
          type: "milestone"
        });
      } else {
        updatedTableItems.splice(updatedTableItems.length - 1, 1);
        this.setState({
          tableItems: updatedTableItems
        });
      }
    } else {
      if (!openMilestoneEdit) {
        // let getRowIndex = updatedTableItems.findIndex(item => item.id === id);
        // updatedTableItems.splice(getRowIndex, 1);
        let getRowIndex = updatedTableItems.findIndex(
          item => Number(item.id) === Number(id)
        );
        if (getRowIndex !== -1) updatedTableItems.splice(getRowIndex, 1);
        this.setState({ tableItems: updatedTableItems }, () => {
          onChange(null, "deleteRow", bucketId, id, name, tableIndex, true);
        });
        deleteNewMilestoneAction({
          milestoneID: id,
          bucketID: bucketId,
          phaseIndex: tableIndex,
          type: "milestone"
        });
      }
    }
  };

  handleMilestone = event => {
    event.preventDefault();
    const { tableItems } = this.state;
    let updatedTableItems = [...tableItems];
    updatedTableItems[updatedTableItems.length - 1].name = event.target.value;
    this.setState({
      tableItems: updatedTableItems
    });
  };

  createMilestoneHandler = async event => {
    event.preventDefault();
    const { tableItems } = this.state;
    const {
      createMilestoneAction,
      saveNewMilestoneAction,
      bucketId,
      onChange,
      tableIndex
    } = this.props;
    let updatedTableItems = [...tableItems];
    const payload = {
      name: event.target.value
    };
    const newRowData = {
      id: null,
      name: event.target.value,
      bucketId: bucketId,
      newRow: true,
      predefined: false,
      phaseIndex: tableIndex
    };
    if (!!event.target.value) {
      try {
        const resp = await createMilestoneAction(undefined, payload);
        if (resp) {
          const { data } = resp;
          updatedTableItems[updatedTableItems.length - 1].id = data;
          newRowData.id = data;
          if (newRowData.id != null) {
            saveNewMilestoneAction(newRowData);
            this.setState(
              {
                tableItems: updatedTableItems
              },
              () => {
                onChange(
                  "",
                  "addRow",
                  bucketId,
                  data,
                  payload.name,
                  tableIndex,
                  true
                );
              }
            );
          }
        }
      } catch (err) {
        console.log("Error adding milestone -", err.message);
      }
    }
  };

  handleDependencyModal = () => {
    this.setState({
      showInfoPopup: !this.state.showInfoPopup
    });
  };
  removeNewPhaseItem = (id, bucketIndex) => {
    if (id != null) {
      const { tableItems } = this.state;
      let updatedTableItems = [...tableItems];
      const { milestones, tableIndex, bucketMilestoneCOS } = this.props;

      let selectedPhaseItemIndex = bucketMilestoneCOS[
        bucketIndex
      ].milestoneTableDataCOS[tableIndex].milestoneDataCOS.findIndex(
        item => item.milestone.id === id
      );
      bucketMilestoneCOS[bucketIndex].milestoneTableDataCOS[
        tableIndex
      ].milestoneDataCOS.splice(selectedPhaseItemIndex, 1);
      // let getRowIndex = updatedTableItems.findIndex(item => item.id === id);
      // updatedTableItems.splice(getRowIndex, 1);

      let getRowIndex = updatedTableItems.findIndex(
        item => Number(item.id) === Number(id)
      );
      if (getRowIndex !== -1) updatedTableItems.splice(getRowIndex, 1);
      !!milestones &&
        !!milestones[bucketIndex] &&
        !!milestones[bucketIndex].newMilestoneData &&
        !!milestones[bucketIndex].newMilestoneData[tableIndex] &&
        milestones[bucketIndex].newMilestoneData[tableIndex].splice(
          getRowIndex,
          1
        );

      this.setState({
        tableItems: updatedTableItems
      });
    } else {
      const { tableItems } = this.state;
      let updatedTableItems = [...tableItems];
      // let getRowIndex = updatedTableItems.findIndex(item => item.id === id);
      // updatedTableItems.splice(getRowIndex, 1);

      let getRowIndex = updatedTableItems.findIndex(
        item => Number(item.id) === Number(id)
      );
      if (getRowIndex !== -1) updatedTableItems.splice(getRowIndex, 1);
      this.setState({ tableItems: updatedTableItems });
    }
  };

  render() {
    const {
      onChange,
      bucketId,
      responsibleAuthority,
      tableIndex,
      openedFromComplete,
      bucketMilestoneCOS,
      className,
      isBucketCompleted,
      groupCategory,
      openMilestoneEdit,
      projectDetailBucketMilestoneCOS = [],
      isMilestoneTableValidated,
      editMilestoneOriginalDate,
      cabinetMilestone,
      milestones,
      sponsoredByCategory,
      isEdit,
      milestoneError,
      isCabinetMilestoneMandatoryExempt,
      isCabinetMilestoneMandatoryEditExempt
    } = this.props;
    const {
      tableItems,
      showPopup,
      showInfoPopup,
      milestoneDataForReason: { reason, milestoneName, key },
      startDates
    } = this.state;
    const depTypeOptions = [
      "INDEPENDENT",
      "FINISH_TO_START",
      "START_TO_START",
      "FINISH_TO_FINISH",
      "START_TO_FINISH"
    ];
    var dateValidation;
    const dateValidator = flag => {
      if (!flag) {
        dateValidation = false;
      }
    };
    const userInfo = getLocalstorage("user");
    const isUserPP = userInfo.groupCategory === "PP";
    return (
      <>
        <Form.Group
          className={`${className} milestone-table`}
          style={{
            paddingBottom:
              cabinetMilestone &&
              isEmpty(tableItems) &&
              get(milestoneError, "error")
                ? 5
                : null
          }}
        >
          <DragDropContext
            onDragEnd={results => this.handleDragEnd(results)}
            onDragStart={results => this.handleDragStart(results)}
          >
            <Table className="table" cellPadding="10" cellSpacing="0">
              <thead>
                <tr>
                  <th
                    rowSpan="2"
                    className="no-border-bottom"
                    data-test="label-mark-as-complete"
                  >
                    Mark as complete
                  </th>
                  <th
                    rowSpan="2"
                    className="no-border-bottom"
                    data-test="label-serial-number"
                  >
                    S.No
                  </th>
                  <th
                    rowSpan="2"
                    className="no-border-bottom"
                    data-test="label-measurable-milestone-or-activity"
                  >
                    Measurable Milestone / Activity
                  </th>
                  <th colSpan="2" data-test="label-schedule-date-of-start">
                    Scheduled date of start
                  </th>
                  <th colSpan="2" data-test="label-schedule-date-of-finish">
                    Scheduled date of finish
                  </th>
                  <th
                    rowSpan="2"
                    className="no-border-bottom"
                    data-test="label-responsible-agency-or-authority-involve"
                  >
                    Responsible Agency/ Authority Involved
                    <span class="required">*</span>
                  </th>
                  <th
                    rowSpan="2"
                    className="no-border-bottom"
                    data-test="label-reason-for-delay"
                  >
                    Reason For Delay
                  </th>
                  {/* <th className="no-border-bottom">Add Issues(s)</th> */}
                  <th
                    rowSpan="2"
                    className="no-border-bottom"
                    data-test="label-dependency-type"
                  >
                    Dependency Type
                    <span class="required">*</span>
                    <img
                      onClick={this.handleDependencyModal}
                      src={MilestoneInfoIcon}
                      className="dependency-icon"
                    />
                  </th>
                  <th
                    rowSpan="2"
                    className="no-border-bottom"
                    data-test="label-linked-activity"
                  >
                    Linked Activity
                    <span class="required">*</span>
                  </th>
                  <th
                    rowSpan="2"
                    className="no-border-bottom"
                    data-test="label-actions"
                  >
                    Actions
                  </th>
                </tr>
                <tr>
                  {/* <th className="no-border-top" />
                  <th className="no-border-top" />
                  <th className="no-border-top" /> */}
                  <th
                    className="th-padding"
                    data-test="label-start-original-date"
                  >
                    Original<span class="required">*</span>
                  </th>
                  <th
                    className="th-padding"
                    data-test="label-start-revised-or-actual-date"
                  >
                    Revised/Actual
                  </th>
                  <th
                    className="th-padding"
                    data-test="label-start-original-date"
                  >
                    Original<span class="required">*</span>
                  </th>
                  <th
                    className="th-padding"
                    data-test="label-start-revised-or-actual-date"
                  >
                    Revised/Actual
                  </th>
                  {/* <th className="no-border-top" />
                  <th className="no-border-top" />
                  {/* <th className="no-border-top" /> */}
                  {/* <th className="no-border-top" />
                  <th className="no-border-top" />
                  <th className="no-border-top" /> */}
                </tr>
              </thead>
              <Droppable droppableId="tbody">
                {provided => (
                  <tbody ref={provided.innerRef} {...provided.droppableProps}>
                    {!isEmpty(tableItems) &&
                      tableItems.map((item, index) => {
                        const getMilestoneData =
                          bucketMilestoneCOS &&
                          bucketMilestoneCOS.find(o => o.bucketId === bucketId);
                        const getMilestoneDataCOS =
                          getMilestoneData &&
                          getMilestoneData.milestoneTableDataCOS &&
                          getMilestoneData.milestoneTableDataCOS[tableIndex] &&
                          getMilestoneData.milestoneTableDataCOS[tableIndex]
                            .milestoneDataCOS;

                        const _bucketIndex =
                          bucketMilestoneCOS &&
                          bucketMilestoneCOS.findIndex(
                            o => o.bucketId === bucketId
                          );

                        const _tableIndex =
                          bucketMilestoneCOS &&
                          bucketMilestoneCOS[_bucketIndex] &&
                          bucketMilestoneCOS[
                            _bucketIndex
                          ].milestoneTableDataCOS.findIndex(
                            o => o.tableIndex === tableIndex
                          );

                        const depIndex =
                          bucketMilestoneCOS &&
                          bucketMilestoneCOS[_bucketIndex] &&
                          bucketMilestoneCOS[_bucketIndex]
                            .milestoneTableDataCOS[_tableIndex] &&
                          bucketMilestoneCOS[
                            _bucketIndex
                          ].milestoneTableDataCOS[
                            _tableIndex
                          ].milestoneDataCOS.findIndex(
                            o => o && o.milestone && o.milestone.id == item.id
                          );

                        let _getMilestone =
                          !!bucketMilestoneCOS &&
                          !!bucketMilestoneCOS[_bucketIndex] &&
                          !!bucketMilestoneCOS[_bucketIndex]
                            .milestoneTableDataCOS &&
                          !!bucketMilestoneCOS[_bucketIndex]
                            .milestoneTableDataCOS[_tableIndex] &&
                          !!bucketMilestoneCOS[_bucketIndex]
                            .milestoneTableDataCOS[_tableIndex]
                            .milestoneDataCOS &&
                          !!bucketMilestoneCOS[_bucketIndex]
                            .milestoneTableDataCOS[_tableIndex]
                            .milestoneDataCOS[depIndex] &&
                          bucketMilestoneCOS[_bucketIndex]
                            .milestoneTableDataCOS[_tableIndex]
                            .milestoneDataCOS[depIndex];
                        let checkIsDisabled =
                          depIndex === -1 ||
                          !_getMilestone.dependencyType ||
                          _getMilestone.dependencyType === "INDEPENDENT";
                        let disabledForCabinet = false;
                        if (cabinetMilestone) {
                          disabledForCabinet =
                            milestones &&
                            milestones.length > 0 &&
                            milestones[0].newMilestoneData &&
                            milestones[0].newMilestoneData.length > 0 &&
                            milestones[0].newMilestoneData[0] &&
                            milestones[0].newMilestoneData[0].length === 1
                              ? true
                              : false;
                        }

                        let checkDelayReasonAdded =
                          _getMilestone.reasonForDelay;

                        let isActionDisabled = !_getMilestone.disabled;

                        let isChecked = _getMilestone.completed;

                        let isResponsibleAgencyOthers =
                          get(_getMilestone, "responsibleAuthorityName", "") ===
                          "Others";
                        if (
                          this.handleCheckboxChange(
                            _getMilestone.revisedScheduledFinishDate,
                            _getMilestone.originalScheduledFinishDate
                          ) == true
                        ) {
                          _getMilestone.completed = false;
                        } else {
                          //checkboxChecked = _getMilestone.completed;
                        }
                        return (
                          <Draggable
                            draggableId={!!item.id && item.id.toString()}
                            index={index}
                            key={item.id}
                          >
                            {provided => (
                              <tr
                                ref={provided.innerRef}
                                {...provided.dragHandleProps}
                                {...provided.draggableProps}
                              >
                                <td
                                  className={
                                    isResponsibleAgencyOthers
                                      ? "vertical-top"
                                      : ""
                                  }
                                >
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip
                                        //id={index}
                                        className={`markas_completed_tolltip`}
                                      >
                                        Can't mark as complete as <br />
                                        <span
                                          style={{
                                            marginLeft: -5,
                                            paddingTop: "-1em"
                                          }}
                                        >
                                          the finish date is in future
                                        </span>
                                      </Tooltip>
                                    }
                                  >
                                    <Image
                                      src={DisableCheckbox}
                                      alt="Filter Icon"
                                      style={{
                                        cursor: "pointer",
                                        borderRadius: 2,
                                        display: this.handleCheckboxChange(
                                          _getMilestone.revisedScheduledFinishDate,
                                          _getMilestone.originalScheduledFinishDate
                                        )
                                          ? null
                                          : "none"
                                      }}
                                    />
                                    {/* <Form.Check
                                      className={`form-checkbox`}
                                      style={{
                                        display: this.handleCheckboxChange(
                                          _getMilestone.revisedScheduledFinishDate,
                                          _getMilestone.originalScheduledFinishDate
                                        )
                                          ? null
                                          : "none"
                                      }}
                                    >
                                      <Form.Check.Input
                                        type="checkbox"
                                        name="mark"
                                         disabled
                                      />
                                      <Form.Check.Label
                                        className={"disabled"}
                                        onClick={e => {
                                          e.stopPropagation();
                                          let checked = _getMilestone.completed
                                            ? false
                                            : true;
                                          onChange(
                                            checked,
                                            "checkMark",
                                            bucketId,
                                            item.id,
                                            item.name,
                                            tableIndex,
                                            true
                                          );
                                        }}
                                      />
                                    </Form.Check> */}
                                  </OverlayTrigger>

                                  <Form.Check
                                    className={`form-checkbox ${
                                      _getMilestone.completed === true
                                        ? " checked"
                                        : ""
                                    }`}
                                    style={{
                                      display: this.handleCheckboxChange(
                                        _getMilestone.revisedScheduledFinishDate,
                                        _getMilestone.originalScheduledFinishDate
                                      )
                                        ? "none"
                                        : null
                                    }}
                                  >
                                    <Form.Check.Input
                                      type="checkbox"
                                      name="mark"
                                      disabled={
                                        openedFromComplete ||
                                        !isActionDisabled ||
                                        item.id === null
                                      }
                                    />
                                    <Form.Check.Label
                                      className={
                                        openedFromComplete ||
                                        !isActionDisabled ||
                                        item.id === null
                                          ? "disabled"
                                          : ""
                                      }
                                      onClick={e => {
                                        e.stopPropagation();
                                        let checked = _getMilestone.completed
                                          ? false
                                          : true;
                                        this.handleCheckbox(
                                          _getMilestone.id,
                                          checked
                                        );
                                        onChange(
                                          checked,
                                          "checkMark",
                                          bucketId,
                                          item.id,
                                          item.name,
                                          tableIndex,
                                          true
                                        );
                                      }}
                                    >
                                      <span />
                                    </Form.Check.Label>
                                  </Form.Check>
                                </td>

                                <td
                                  className={
                                    isResponsibleAgencyOthers
                                      ? "vertical-top"
                                      : ""
                                  }
                                >
                                  {index + 1}
                                </td>
                                <td
                                  className={
                                    isResponsibleAgencyOthers
                                      ? "vertical-top"
                                      : ""
                                  }
                                >
                                  {item.id !== null ? (
                                    item.name
                                  ) : (
                                    <input
                                      type="text"
                                      name="milestone-name"
                                      className="milestone-name"
                                      value={item.name}
                                      onBlur={e =>
                                        this.createMilestoneHandler(e)
                                      }
                                      onChange={e => this.handleMilestone(e)}
                                    />
                                  )}
                                </td>
                                <td
                                  className={
                                    isResponsibleAgencyOthers
                                      ? "vertical-top"
                                      : ""
                                  }
                                >
                                  <DatePickerStyled
                                    isClearable={
                                      _getMilestone.originalScheduledStartDate
                                    }
                                    sponsoredByCategory={sponsoredByCategory}
                                    selected={
                                      _getMilestone.originalScheduledStartDate ||
                                      undefined
                                    }
                                    value={
                                      _getMilestone.originalScheduledStartDate
                                    }
                                    setZIndex={this.ZIndex}
                                    onChange={value => {
                                      if (
                                        value !==
                                        _getMilestone.originalScheduledStartDate
                                      ) {
                                        onChange(
                                          value,
                                          "startOriginal",
                                          bucketId,
                                          item.id,
                                          item.name,
                                          tableIndex,
                                          true
                                        );
                                      }
                                    }}
                                    style={{ fontSize: 0 }}
                                    // disabled={
                                    //   openedFromComplete ||
                                    //   !isActionDisabled ||
                                    //   item.id === null ||
                                    //   startDates.includes(_getMilestone.id) ||
                                    //   _getMilestone.completed ||
                                    //   (openMilestoneEdit &&
                                    //     !getMilestoneData.editBucketPermission &&
                                    //     !_getMilestone.editMilestonePermission &&
                                    //     !editMilestoneOriginalDate)
                                    // }
                                    disabled={
                                      openedFromComplete ||
                                      !isActionDisabled ||
                                      item.id === null ||
                                      startDates.includes(_getMilestone.id) ||
                                      _getMilestone.completed ||
                                      ((openMilestoneEdit ||
                                        (cabinetMilestone &&
                                          isUserPP &&
                                          isEdit)) &&
                                        !get(
                                          getMilestoneData,
                                          "editBucketPermission"
                                        ) &&
                                        !get(
                                          _getMilestone,
                                          "editMilestonePermission"
                                        ) &&
                                        !editMilestoneOriginalDate)
                                    }
                                    maxDate={
                                      _getMilestone.originalScheduledFinishDate ==
                                      null
                                        ? null
                                        : _getMilestone.originalScheduledFinishDate
                                    }
                                    openToDate={
                                      (_getMilestone.originalScheduledFinishDate !=
                                        null ||
                                      _getMilestone.originalScheduledStartDate ==
                                        null
                                        ? null
                                        : _getMilestone.originalScheduledFinishDate) ||
                                      (_getMilestone.originalScheduledStartDate !=
                                      null
                                        ? _getMilestone.originalScheduledStartDate
                                        : null)
                                    }
                                    // className={
                                    //   (openedFromComplete ||
                                    //   !isActionDisabled ||
                                    //   item.id === null ||
                                    //   dateValidation === false ||
                                    //   startDates.includes(_getMilestone.id) ||
                                    //   _getMilestone.completed ||
                                    //   (openMilestoneEdit &&
                                    //     !getMilestoneData.editBucketPermission &&
                                    //     !_getMilestone.editMilestonePermission &&
                                    //     !editMilestoneOriginalDate)
                                    //     ? "disabled-date"
                                    //     : "") +
                                    //   (isMilestoneTableValidated === false &&
                                    //   !_getMilestone.disabled &&
                                    //   !_getMilestone.originalScheduledStartDate
                                    //     ? " error-milestone"
                                    //     : "")
                                    // }
                                    className={
                                      (openedFromComplete ||
                                      !isActionDisabled ||
                                      item.id === null ||
                                      dateValidation === false ||
                                      startDates.includes(_getMilestone.id) ||
                                      _getMilestone.completed ||
                                      ((openMilestoneEdit ||
                                        (cabinetMilestone &&
                                          isUserPP &&
                                          isEdit)) &&
                                        !get(
                                          getMilestoneData,
                                          "editBucketPermission"
                                        ) &&
                                        !get(
                                          _getMilestone,
                                          "editMilestonePermission"
                                        ) &&
                                        !editMilestoneOriginalDate)
                                        ? "disabled-date"
                                        : "") +
                                      (isMilestoneTableValidated === false &&
                                      !_getMilestone.disabled &&
                                      !_getMilestone.originalScheduledStartDate &&
                                      ((!isEdit &&
                                        !isCabinetMilestoneMandatoryExempt) ||
                                        (isEdit &&
                                          !isCabinetMilestoneMandatoryEditExempt))
                                        ? " error-milestone"
                                        : "")
                                    }
                                    originalScheduledFinishDate={
                                      _getMilestone.originalScheduledFinishDate
                                    }
                                  />
                                </td>
                                <td
                                  className={
                                    isResponsibleAgencyOthers
                                      ? "vertical-top"
                                      : ""
                                  }
                                >
                                  <DatePickerStyled
                                    isClearable={
                                      _getMilestone.revisedScheduledStartDate
                                    }
                                    sponsoredByCategory={sponsoredByCategory}
                                    setZIndex={this.ZIndex}
                                    selected={
                                      _getMilestone.revisedScheduledStartDate
                                    }
                                    value={
                                      _getMilestone.revisedScheduledStartDate
                                    }
                                    onChange={value => {
                                      onChange(
                                        value,
                                        "startRevised",
                                        bucketId,
                                        item.id,
                                        item.name,
                                        tableIndex,
                                        true
                                      );
                                    }}
                                    maxDate={
                                      _getMilestone.revisedScheduledFinishDate ==
                                      null
                                        ? null
                                        : _getMilestone.revisedScheduledFinishDate
                                    }
                                    openToDate={
                                      (_getMilestone.revisedScheduledFinishDate !=
                                        null ||
                                      _getMilestone.revisedScheduledStartDate ==
                                        null
                                        ? null
                                        : _getMilestone.revisedScheduledFinishDate) ||
                                      (_getMilestone.revisedScheduledStartDate !=
                                      null
                                        ? _getMilestone.revisedScheduledStartDate
                                        : null)
                                    }
                                    disabled={
                                      openedFromComplete ||
                                      !isActionDisabled ||
                                      item.id === null ||
                                      startDates.includes(_getMilestone.id) ||
                                      _getMilestone.completed
                                    }
                                    className={
                                      openedFromComplete ||
                                      !isActionDisabled ||
                                      item.id === null ||
                                      startDates.includes(_getMilestone.id) ||
                                      _getMilestone.completed
                                        ? "disabled-date"
                                        : ""
                                    }
                                    revisedScheduledFinishDate={
                                      _getMilestone.revisedScheduledFinishDate
                                    }
                                  />
                                </td>
                                <td
                                  className={
                                    isResponsibleAgencyOthers
                                      ? "vertical-top"
                                      : ""
                                  }
                                >
                                  <DatePickerStyled
                                    isClearable={
                                      _getMilestone.originalScheduledFinishDate
                                    }
                                    sponsoredByCategory={sponsoredByCategory}
                                    selected={
                                      _getMilestone.originalScheduledFinishDate
                                    }
                                    value={
                                      _getMilestone.originalScheduledFinishDate
                                    }
                                    onChange={value => {
                                      onChange(
                                        value,
                                        "finishOriginal",
                                        bucketId,
                                        item.id,
                                        item.name,
                                        tableIndex,
                                        true
                                      );
                                    }}
                                    disabled={
                                      openedFromComplete ||
                                      !isActionDisabled ||
                                      item.id === null ||
                                      startDates.includes(_getMilestone.id) ||
                                      _getMilestone.completed ||
                                      ((openMilestoneEdit ||
                                        (cabinetMilestone &&
                                          isUserPP &&
                                          isEdit)) &&
                                        !get(
                                          getMilestoneData,
                                          "editBucketPermission"
                                        ) &&
                                        !get(
                                          _getMilestone,
                                          "editMilestonePermission"
                                        ) &&
                                        !editMilestoneOriginalDate)
                                    }
                                    minDate={
                                      _getMilestone.originalScheduledStartDate ==
                                      null
                                        ? null
                                        : _getMilestone.originalScheduledStartDate
                                    }
                                    openToDate={
                                      (_getMilestone.originalScheduledFinishDate !=
                                        null &&
                                      _getMilestone.originalScheduledStartDate !=
                                        null
                                        ? _getMilestone.originalScheduledFinishDate
                                        : null) ||
                                      (_getMilestone.originalScheduledStartDate !=
                                      null
                                        ? _getMilestone.originalScheduledStartDate
                                        : null)
                                    }
                                    setZIndex={this.ZIndex}
                                    className={
                                      (openedFromComplete ||
                                      !isActionDisabled ||
                                      item.id === null ||
                                      startDates.includes(_getMilestone.id) ||
                                      _getMilestone.completed ||
                                      ((openMilestoneEdit ||
                                        (cabinetMilestone &&
                                          isUserPP &&
                                          isEdit)) &&
                                        !get(
                                          getMilestoneData,
                                          "editBucketPermission"
                                        ) &&
                                        !get(
                                          _getMilestone,
                                          "editMilestonePermission"
                                        ) &&
                                        !editMilestoneOriginalDate)
                                        ? "disabled-date"
                                        : "") +
                                      (isMilestoneTableValidated === false &&
                                      !_getMilestone.disabled &&
                                      !_getMilestone.originalScheduledFinishDate &&
                                      ((!isEdit &&
                                        !isCabinetMilestoneMandatoryExempt) ||
                                        (isEdit &&
                                          !isCabinetMilestoneMandatoryEditExempt))
                                        ? " error-milestone"
                                        : "")
                                    }
                                    originalScheduledStartDate={
                                      _getMilestone.originalScheduledStartDate
                                    }
                                  />
                                </td>
                                <td
                                  className={
                                    isResponsibleAgencyOthers
                                      ? "vertical-top"
                                      : ""
                                  }
                                >
                                  <DatePickerStyled
                                    isClearable={
                                      _getMilestone.revisedScheduledFinishDate
                                    }
                                    selected={
                                      _getMilestone.revisedScheduledFinishDate
                                    }
                                    sponsoredByCategory={sponsoredByCategory}
                                    value={
                                      _getMilestone.revisedScheduledFinishDate
                                    }
                                    onChange={value => {
                                      onChange(
                                        value,
                                        "finishRevised",
                                        bucketId,
                                        item.id,
                                        item.name,
                                        tableIndex,
                                        true
                                      );
                                    }}
                                    minDate={
                                      _getMilestone.revisedScheduledStartDate ==
                                      null
                                        ? null
                                        : _getMilestone.revisedScheduledStartDate
                                    }
                                    openToDate={
                                      (_getMilestone.revisedScheduledFinishDate !=
                                        null &&
                                      _getMilestone.revisedScheduledStartDate !=
                                        null
                                        ? _getMilestone.revisedScheduledFinishDate
                                        : null) ||
                                      (_getMilestone.revisedScheduledStartDate !=
                                      null
                                        ? _getMilestone.revisedScheduledStartDate
                                        : null)
                                    }
                                    disabled={
                                      openedFromComplete ||
                                      !isActionDisabled ||
                                      item.id === null ||
                                      startDates.includes(_getMilestone.id) ||
                                      _getMilestone.completed
                                    }
                                    setZIndex={this.ZIndex}
                                    className={
                                      openedFromComplete ||
                                      !isActionDisabled ||
                                      item.id === null ||
                                      startDates.includes(_getMilestone.id) ||
                                      _getMilestone.completed
                                        ? "disabled-date"
                                        : ""
                                    }
                                    revisedScheduledStartDate={
                                      _getMilestone.revisedScheduledStartDate
                                    }
                                  />
                                </td>
                                <td
                                  className={
                                    isResponsibleAgencyOthers
                                      ? "vertical-top"
                                      : ""
                                  }
                                >
                                  <select
                                    className={
                                      "form-control" +
                                      (isMilestoneTableValidated === false &&
                                      !_getMilestone.disabled &&
                                      !_getMilestone.responsibleAuthorityId &&
                                      ((!isEdit &&
                                        !isCabinetMilestoneMandatoryExempt) ||
                                        (isEdit &&
                                          !isCabinetMilestoneMandatoryEditExempt))
                                        ? " error-milestone"
                                        : "")
                                    }
                                    onChange={e => {
                                      let authIndex =
                                        !!responsibleAuthority &&
                                        responsibleAuthority.findIndex(
                                          auth => auth.id == e.target.value
                                        );
                                      return onChange(
                                        {
                                          id: e.target.value,
                                          name:
                                            responsibleAuthority[authIndex].name
                                        },
                                        "authority",
                                        bucketId,
                                        item.id,
                                        item.name,
                                        tableIndex,
                                        true
                                      );
                                    }}
                                    value={_getMilestone.responsibleAuthorityId}
                                    disabled={
                                      openedFromComplete ||
                                      !isActionDisabled ||
                                      item.id === null ||
                                      startDates.includes(_getMilestone.id) ||
                                      _getMilestone.completed
                                    }
                                  >
                                    <option value="" disabled selected>
                                      SELECT
                                    </option>
                                    {responsibleAuthority &&
                                      responsibleAuthority.map(auth => {
                                        return (
                                          <option value={auth.id}>
                                            {auth.name}
                                          </option>
                                        );
                                      })}
                                  </select>
                                  {get(
                                    _getMilestone,
                                    "responsibleAuthorityName",
                                    ""
                                  ) === "Others" ? (
                                    <Form.Group className="others-responsible-agency">
                                      <div
                                        className={
                                          "form-field" +
                                          (isMilestoneTableValidated ===
                                            false &&
                                          !_getMilestone.disabled &&
                                          !_getMilestone.otherResponsibleAuthority &&
                                          ((!isEdit &&
                                            !isCabinetMilestoneMandatoryExempt) ||
                                            (isEdit &&
                                              !isCabinetMilestoneMandatoryEditExempt))
                                            ? " error-milestone"
                                            : "")
                                        }
                                      >
                                        <Form.Control
                                          type="text"
                                          placeholder={`Enter text here`}
                                          onChange={e => {
                                            onChange(
                                              e.target.value,
                                              "otherResponsibleAuthority",
                                              bucketId,
                                              item.id,
                                              item.name,
                                              tableIndex,
                                              true
                                            );
                                          }}
                                          value={get(
                                            _getMilestone,
                                            "otherResponsibleAuthority",
                                            ""
                                          )}
                                          disabled={
                                            openedFromComplete ||
                                            !isActionDisabled ||
                                            item.id === null ||
                                            _getMilestone.completed ||
                                            startDates.includes(
                                              _getMilestone.id
                                            )
                                          }
                                        />
                                      </div>
                                    </Form.Group>
                                  ) : null}
                                </td>
                                <td
                                  className={
                                    isResponsibleAgencyOthers
                                      ? "vertical-top"
                                      : ""
                                  }
                                >
                                  <button
                                    className="milestone-activity"
                                    onClick={event =>
                                      this.onModalChange(
                                        event,
                                        "addReason",
                                        bucketId,
                                        item.id,
                                        item.name,
                                        checkDelayReasonAdded
                                      )
                                    }
                                    disabled={
                                      openedFromComplete ||
                                      !isActionDisabled ||
                                      item.id === null ||
                                      startDates.includes(_getMilestone.id) ||
                                      _getMilestone.completed
                                    }
                                  >
                                    {!!checkDelayReasonAdded ? "Edit" : "Add"}
                                  </button>
                                </td>
                                <td
                                  className={
                                    isResponsibleAgencyOthers
                                      ? "vertical-top"
                                      : ""
                                  }
                                >
                                  <select
                                    className={
                                      "form-control" +
                                      (isMilestoneTableValidated === false &&
                                      !_getMilestone.disabled &&
                                      !_getMilestone.dependencyType &&
                                      ((!isEdit &&
                                        !isCabinetMilestoneMandatoryExempt) ||
                                        (isEdit &&
                                          !isCabinetMilestoneMandatoryEditExempt))
                                        ? " error-milestone"
                                        : "")
                                    }
                                    onChange={e =>
                                      onChange(
                                        e.target.value,
                                        "dep_type",
                                        bucketId,
                                        item.id,
                                        item.name,
                                        tableIndex,
                                        true
                                      )
                                    }
                                    value={_getMilestone.dependencyType}
                                    disabled={
                                      openedFromComplete ||
                                      !isActionDisabled ||
                                      item.id === null ||
                                      startDates.includes(_getMilestone.id) ||
                                      _getMilestone.completed
                                    }
                                  >
                                    <option value="" disabled selected>
                                      SELECT
                                    </option>
                                    {depTypeOptions.map(typeOptions => (
                                      <option value={typeOptions}>
                                        {DEPENDENT_TYPE[typeOptions]}
                                      </option>
                                    ))}
                                  </select>
                                </td>
                                <td
                                  className={
                                    isResponsibleAgencyOthers
                                      ? "vertical-top"
                                      : ""
                                  }
                                >
                                  <select
                                    class={
                                      "form-control" +
                                      (isMilestoneTableValidated === false &&
                                      !_getMilestone.disabled &&
                                      (!!_getMilestone.dependencyType &&
                                        _getMilestone.dependencyType !==
                                          "INDEPENDENT") &&
                                      !_getMilestone.dependentOnId &&
                                      ((!isEdit &&
                                        !isCabinetMilestoneMandatoryExempt) ||
                                        (isEdit &&
                                          !isCabinetMilestoneMandatoryEditExempt))
                                        ? " error-milestone"
                                        : "")
                                    }
                                    onChange={e => {
                                      let typeIndex = tableItems.findIndex(
                                        item => item.id == e.target.value
                                      );
                                      return onChange(
                                        {
                                          id: e.target.value,
                                          name: tableItems[typeIndex].name
                                        },
                                        "dep_on",
                                        bucketId,
                                        item.id,
                                        item.name,
                                        tableIndex,
                                        true
                                      );
                                    }}
                                    value={_getMilestone.dependentOnId}
                                    disabled={
                                      checkIsDisabled ||
                                      disabledForCabinet ||
                                      openedFromComplete ||
                                      !isActionDisabled ||
                                      item.id === null ||
                                      startDates.includes(_getMilestone.id) ||
                                      _getMilestone.completed
                                    }
                                  >
                                    <option
                                      selected={
                                        _getMilestone.dependentOnId == null
                                          ? "selected"
                                          : ""
                                      }
                                      disabled
                                    >
                                      SELECT
                                    </option>
                                    {!checkIsDisabled
                                      ? tableItems.map(depOn => {
                                          const selectedMilestone =
                                            getMilestoneDataCOS &&
                                            getMilestoneDataCOS.find(
                                              item =>
                                                item.milestone &&
                                                item.milestone.id === depOn.id
                                            );
                                          if (
                                            depOn.id !== item.id &&
                                            selectedMilestone &&
                                            !selectedMilestone.disabled
                                          ) {
                                            return (
                                              <option value={depOn.id}>
                                                {depOn.name}
                                              </option>
                                            );
                                          }
                                        })
                                      : null}
                                  </select>
                                </td>
                                <td
                                  className={
                                    isResponsibleAgencyOthers
                                      ? "vertical-top"
                                      : ""
                                  }
                                  align="center"
                                >
                                  {isBucketCompleted ? null : item.predefined ? (
                                    <OverlayTrigger
                                      placement="top"
                                      delay={{ show: 250, hide: 400 }}
                                      overlay={
                                        <Tooltip
                                          id={index}
                                          className={`issues-actions-tooltip`}
                                        >
                                          {_getMilestone.disabled
                                            ? "Enable "
                                            : "Disable "}
                                          {item.name}
                                        </Tooltip>
                                      }
                                    >
                                      <div className="disable-btn">
                                        <label className="switch">
                                          <input
                                            type="checkbox"
                                            checked={isActionDisabled}
                                            onChange={e =>
                                              this.onModalChange(
                                                e,
                                                "action",
                                                bucketId,
                                                item.id,
                                                item.name,
                                                null,
                                                !e.target.checked,
                                                _bucketIndex,
                                                tableIndex
                                              )
                                            }
                                            disabled={isChecked}
                                          />
                                          <span className="slider round" />
                                        </label>
                                      </div>
                                    </OverlayTrigger>
                                  ) : (
                                    <img
                                      src={deleteIcon}
                                      className="delete-milestone"
                                      onClick={e =>
                                        this.deleteRow(
                                          e,
                                          item.id,
                                          item.name,
                                          _bucketIndex,
                                          tableIndex
                                        )
                                      }
                                    />
                                  )}
                                </td>
                              </tr>
                            )}
                          </Draggable>
                        );
                      })}
                    {!isBucketCompleted && (
                      <tr
                        className={
                          "add-table-row" +
                          (cabinetMilestone &&
                          isEmpty(tableItems) &&
                          get(milestoneError, "error")
                            ? " add-table-row-error"
                            : "")
                        }
                      >
                        <td className="td-font" align="center" colSpan="12">
                          <button
                            className={
                              "milestone-activity" +
                              (tableItems[tableItems.length - 1] &&
                              tableItems[tableItems.length - 1].id == null
                                ? " disabled"
                                : "")
                            }
                            onClick={e => this.addTableRow(e)}
                          >
                            <span className="add-icon"> + </span> Add
                            Milestone/Activity
                          </button>
                        </td>
                      </tr>
                    )}
                    {provided.placeholder}
                  </tbody>
                )}
              </Droppable>
            </Table>
          </DragDropContext>
        </Form.Group>

        {/* Reason For Delay Popup */}
        <Modal
          show={showPopup}
          onHide={this.onModalHide}
          className="milestone-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Reason for {key == "action" ? "disabling " : "delay "}
              of {milestoneName}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="confirm">
              <textarea
                value={reason}
                placeholder="Reason..."
                onChange={e => this.onReasonHandler(e.target.value)}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={this.addReason}
              className={"add-reason-btn" + (!reason ? " disabled" : "")}
            >
              {key === "action" ? "DISABLE" : "ADD"}
            </Button>
          </Modal.Footer>
        </Modal>
        {/* Dependency Type Info Popup */}
        <Modal
          show={showInfoPopup}
          onHide={this.handleDependencyModal}
          className="dependency-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Dependency of the milestone on other milestones
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <h2>Independent</h2>
              <p>Milestone is executed Independently</p>
            </div>
            <div>
              <h2>Finish to Start (A → B)</h2>
              <p>Milestone B can only start when Milestone A has finished</p>
            </div>
            <div>
              <h2>Start to Start (A → B)</h2>
              <p>Milestone B can only start when Milestone A has started</p>
            </div>
            <div>
              <h2>Finish to Finish (A → B)</h2>
              <p>Milestone B can only finish when Milestone A has finished</p>
            </div>
            <div>
              <h2>Start to Finish (A → B)</h2>
              <p>Milestone B can only finish when Milestone A has started</p>
            </div>
            <div>
              <b>E.g.:</b> If Milestone B can only start when Milestone A is
              finished, select the dependency type as ‘Finish to Start’ against
              Milestone B and enter A in the <b>‘Linked Activity’</b> column.
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default MilestoneTable;
